<template>
  <div class='container mt-2 basic-info'>
    <div class='col-md'>
      <div class='card'>
        <div class='card-body'>
          <div class='col-md-12'>
            <div class='row'>
              <div class='col-md-6'>
                <h5 class='float-start card-title'>Trip History</h5>
              </div>
              <div class='col-md-6'></div>
            </div>
          </div>
          <br>
          <div class='col-md-12'>
            <div class='row'>
              <div v-if='isLoading' class='container'>
                <div class='d-flex justify-content-center mt-5'>
                  <loader></loader>
                </div>
              </div>
              <div v-else>
                <table class='table table-bordered table-responsive'>
                  <thead>
                  <th>Route</th>
                  <th>Date Range</th>
                  <th>Trip Type</th>
                  <th>Duty Type</th>
                  <th>Workdays</th>
                  </thead>
                  <tbody>
                  <tr v-for='tripHistory in tripHistories' :key='tripHistory.id'>
                    <td>{{ tripHistory.route_name ? tripHistory.route_name : 'N/A' }}</td>
                    <td>{{ tripHistory.createdAt ? tripHistory.createdAt : 'N/A' }}</td>
                    <td>{{ tripHistory.tripType ? tripHistory.tripType : 'N/A' }}</td>
                    <td>{{ tripHistory.duty_type ? tripHistory.duty_type : 'N/A' }}</td>
                    <td>{{ tripHistory.week_days ? tripHistory.week_days : 'N/A' }}</td>
                  </tr>
                  </tbody>
                </table>

              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import b2bService from '../../config/axiosB2BService';
import driverService from '../../config/axiosDriverService';
import Loader from '../lib/Loader';


export default {
  name: 'TripHistory',
  components: {
    Loader
  },
  data() {
    return {
      tripHistories: [],
      isLoading: true
    };
  },
  mounted() {
    this.getTripHistoryB2B();
    this.getB2CDriverHistory();
  },
  methods: {
    getTripHistoryB2B() {
      // http.get('v3/partners/' + `${this.$route.params.id}` + '/trip/history')
      b2bService.get(`trips/driver-filter/${this.$route.params.id}`)
        .then(response => {
          this.tripHistories = response.data.data;
          this.isLoading = false;
        })
        .catch(error => {
          this.errorMessage = error.message;
          console.error('There was an error!', error);
        });
    },
    getB2CDriverHistory() {
      driverService.get(`v2/drivers/${this.$route.params.id}/trips`)
        .then(response => {
          this.tripHistories.concat(response.data.data.data);
          // console.log('history', this.tripHistories);
        })
        .catch(error => {
          this.errorMessage = error.message;
          console.error('There was an error!', error);
        });
    }
  }
};
</script>

<style scoped>

</style>